/* eslint-disable */
import api from "@/service/api";
import dayjs from "dayjs";
import user from "@/stores/user";
import load from "@/common/load";

/*
* 通话录音监控和上传模块
* 
* 功能说明：
* - uniapp在Android11+系统中不支持plus api读取应用目录以外的系统文件目录
* - 需要通过native.js调用Java原生API来读取系统录音文件
* - 通过native调用Java读取时FileInputStream速度较慢，只能循环read()读取
* - JavaScript数据类型无法正常存储读取的二进制数据
* - 无法直接转换为HTML文件上传需要的blob对象
* 
* 解决方案：
* - 通过文件流的Channel将录音文件拷贝到应用可读取的目录
* - 然后调用HTML5Plus API上传文件，实现通话录音文件的读取和上传
* */


/*
* Java类包和全局变量声明
* */
let environment, /* Android环境类，用于获取外部存储目录 */
    File, /* Java文件操作类 */
    Context, /* Android上下文类 */
    FileInputStream, /* 文件输入流类 */
    FileOutputStream, /* 文件输出流类 */
    sdRoot, /* SD卡根目录路径 */
    appFile, /* 应用文件目录路径 */
    teleManager, /* 电话管理器，用于获取通话状态 */
    ActivityManager, /* Activity管理器，用于应用前后台切换 */
    root_path, /* 录音文件存储路径缓存 */
    loaded, /* 标记资源是否已加载 */
    JavaBoolean; /* 布尔值包装器 */


/**
 * 记录运行时的毫秒级时间戳
 * 用于性能监控和调试
 * @param {string} $step - 执行步骤描述
 */
function progress($step) {
    console.log($step, dayjs().format('YYYY-MM-DD HH:mm:ss:SSS'));
}


/**
 * 初始化Android原生类和系统服务
 * 确保所有必要的Java类都已导入并可用
 * 避免重复初始化，提高性能
 */
function construct() {

    /* 避免重复初始化 */
    if (!loaded) {

        /* 导入Android系统相关类 */
        /* 获取Android环境信息类 */
        environment = plus.android.importClass("android.os.Environment");
        /* 文件操作类 */
        File = plus.android.importClass("java.io.File");
        /* Android上下文类 */
        Context = plus.android.importClass("android.content.Context");
        /* 文件输入流类 */
        FileInputStream = plus.android.importClass("java.io.FileInputStream");
        /* 文件输出流类 */
        FileOutputStream = plus.android.importClass("java.io.FileOutputStream");
        JavaBoolean = plus.android.importClass("java.lang.Boolean");


        /* 导入其他必要的系统类 */
        /* 电话管理器类 */
        plus.android.importClass("android.telephony.TelephonyManager");
        /* 文件通道类，用于高效文件复制 */
        plus.android.importClass('java.nio.channels.FileChannel');
        /* Activity管理器类 */
        plus.android.importClass("android.app.ActivityManager");

        /* 初始化系统目录和服务实例 */
        /* 获取外部存储根目录 */
        sdRoot = environment.getExternalStorageDirectory();
        /* 获取应用私有文件目录 */
        appFile = plus.android.runtimeMainActivity().getApplicationContext().getFilesDir().getPath();
        /* 获取电话服务管理器 */
        teleManager = plus.android.runtimeMainActivity().getSystemService(Context.TELEPHONY_SERVICE);
        /* 获取Activity管理器服务 */
        ActivityManager = plus.android.runtimeMainActivity().getSystemService(Context.ACTIVITY_SERVICE);

        /* 标记资源已成功加载 */
        loaded = true;
        progress('construct');

    }
}


/**
 * 根据不同手机品牌获取录音文件存储目录
 * 不同厂商的Android系统录音存储路径各不相同
 * 支持小米、华为、荣耀、魅族、OPPO、vivo、三星等主流品牌
 * @returns {string} 录音文件存储的完整路径
 */
export function getRecordPath() {

    /* 确保Android类已初始化 */
    construct();

    progress('getRecordPath');

    /* 使用缓存避免重复计算路径 */
    if (root_path) return root_path;

    /* 获取设备厂商信息并转为小写 */
    const type = plus.device.vendor.toLowerCase();

    /* 录音文件相对路径 */
    let path = "";

    progress("机型：" + type);

    /* 根据不同手机品牌设置对应的录音存储路径 */
    switch (type) {
        case "xiaomi":
            /* 小米手机MIUI系统录音路径 */
            path = '/MIUI/sound_recorder/call_rec/';
            break;
        case "huawei":
            /* 华为手机录音路径 */
            path = "/Sounds/CallRecord/";
            break;
        case "honor":
            /* 荣耀手机录音路径 */
            path = "/Sounds/CallRecord/";
            break;
        case "nova":
            /* 华为Nova系列录音路径 */
            path = "/Sounds/CallRecord/";
            break;
        case "meizu":
            /* 魅族手机录音路径 */
            path = "/Recorder/";
            break;
        case "oppo":
            /* OPPO手机录音路径 */
            path = "/Music/Recordings/Call Recordings/";
            break;
        case "vivo":
            /* vivo手机录音路径 */
            path = "/Record/Call/";
            break;
        case "samsung":
            /* 三星手机录音路径 */
            path = "/Sounds/";
            break;
        case "oneplus":
            /* 一加手机录音路径 */
            path = "/Music/Recordings/Call Recordings/";
            break;
        case "redmi":
            /* 红米手机录音路径 */
            path = '/MIUI/sound_recorder/call_rec/';
            break;
        case "sony":
            /* 索尼手机录音路径 */
            path = "/Music/PCMRecordings/";
            break;
        case "google":
            /* 谷歌Pixel手机录音路径 */
            path = "/VoiceRecorder/";
            break;
        case "asus":
            /* 华硕手机录音路径 */
            path = "/Recorder/Recordings/";
            break;
        case "lg":
            /* LG手机录音路径 */
            path = "/VoiceRecorder/";
            break;
        case "realme":
            /* realme手机录音路径 */
            path = "/Music/Recordings/Call Recordings/";
            break;
        default:
            /* 对于未列出的机型，使用通用录音存储路径 */
            path = "/Recordings/";
            break;
    }

    /* 拼接完整路径并缓存 */
    root_path = sdRoot + path;
    return sdRoot + path;

}


/**
 * 遍历指定目录下的录音文件
 * 获取目录中的所有文件并按修改时间降序排序，返回最新的文件
 * @param param
 */
export function readDirs(param) {

    /* 确保Android类已初始化 */
    construct();
    progress("readDirs");


    /* 创建目录文件对象 */
    const Dirs = new File(param.path);

    /* 遍历sd卡根目录下的所有文件和文件夹 */
    const files = Dirs.listFiles();

    console.log(files)

    /* 检查目录是否存在录音文件 */
    if (!files || (files && files.length === 0)) {
        return false;
    }

    /* 遍历文件列表，提取文件信息 */
    for (let file of files.reverse()) {
        const lastModify = plus.android.invoke(file, "lastModified");
        if (lastModify > param.callTime) {
            return {
                file: plus.android.invoke(file, "getAbsolutePath"),
                number: files.length
            }
        }
    }


    return false;


}


/**
 * 复制录音文件到应用可访问目录
 * 由于Android11+权限限制，需要将系统录音文件复制到应用私有目录
 * 使用FileChannel进行高效的文件复制操作
 * @param {string} file - 源文件的完整路径
 * @returns {string} 复制后文件在应用目录中的路径
 */
function copy(file) {
    /* 确保Android类已初始化 */
    construct();
    progress("copy");
    /* 创建文件输入流读取源文件 */
    const reader = new FileInputStream(file);
    /* 生成临时文件名，使用时间戳避免冲突，保留原文件格式 */
    const temp = appFile + "/" + (new Date()).getTime() + file.substring(file.lastIndexOf('.'));
    /* 创建文件输出流写入目标文件 */
    const out = new FileOutputStream(temp);
    /* 获取输入流的文件通道 */
    const fisChannel = reader.getChannel();
    /* 获取输出流的文件通道 */
    const fosChannel = out.getChannel();
    /* 使用通道进行高效文件复制，从输入通道传输所有数据到输出通道 */
    fisChannel.transferTo(0, fisChannel.size(), fosChannel);
    /* 关闭输入流释放资源 */
    reader.close();
    /* 关闭输出流释放资源 */
    out.close();
    /* 返回复制后的文件路径 */
    return temp;
}

/**
 * 上传录音文件到服务器
 * 使用HTML5Plus的上传API将录音文件上传到后端服务器
 * @param {string} file - 要上传的文件路径
 * @param {Object} param - 上传参数对象，包含通话信息
 * @returns {Promise<Object>} 上传结果的Promise对象，包含状态码和响应信息
 */
function upload(file, param) {

    /* 确保Android类已初始化 */
    construct();

    progress("upload");

    /* 获取当前用户信息 */
    const userInfo = user();

    return new Promise((resolve => {
        console.log(userInfo, 'userInfouserInfouserInfo')
        /* 创建文件上传任务 */
        const task = plus.uploader.createUpload(`${api.dial.upload}?call=${param.id}`, {
                /* 使用POST方法上传 */
                method: "POST",
                /* 设置上传优先级 */
                priority: 100,
            },
            (ob, status) => {
                console.log(ob, status);
                try {
                    /* 删除临时文件 */
                    unlink(file);
                    /* 判断结果 */
                    if (status === 200) {
                        resolve((JSON.parse(ob)).code);
                    } else {
                        resolve(false);
                    }
                } catch (e) {
                    resolve(false);
                }
            }
        );

        /* 添加要上传的文件，使用file://协议 */
        task.addFile("file://" + file, {
            key: "audio",
            timeout: 120,
            retry: 2,
            retryInterval: 5
        });

        /* 设置用户认证token到请求头 */
        task.setRequestHeader("authorization", userInfo.token);

        /* 开始执行上传任务 */
        task.start();


    }));

}


/**
 * 删除指定路径的文件
 * 用于清理临时文件和录音文件
 * @param {string} path - 要删除的文件路径
 * @returns {boolean} 删除成功返回true，失败返回false
 */
function unlink(path) {

    /* 确保Android类已初始化 */
    construct();

    progress("unlink");

    /* 检查文件路径是否有效 */
    if (!path) return false;

    /* 创建文件对象 */
    let file = new File(path);

    /* 检查文件是否存在并执行删除操作 */
    if (file.exists()) {
        file.delete();
        return true;
    } else {
        return false;
    }
}


/**
 * 处理录音文件上传（简化版本）
 * 直接根据通话时间查找并上传录音文件，不获取通话记录
 * @param {dayjs.Dayjs} callTime - 通话开始时间
 * @param {Object} param - 上传参数对象
 * @returns {Promise<Object>} 上传结果对象
 */
export async function handle(callTime, param) {

    try {

        construct(); /* 初始化Android类和系统服务 */

        progress("start");

        /* 获取手机录音存储的目录 */
        const storage = getRecordPath();

        progress("目录：" + storage);

        /* 判断能否获取录音存储目录 */
        if (!storage) {
            return {
                code: 0,
                msg: "录音文件存储目录获取失败"
            }
        }

        /* 获取最新的录音文件 */
        const audio = readDirs({
            path: storage,
            callTime: callTime.toDate().getTime()
        });

        /* 检查录音文件是否读取成功 */
        if (!audio) {
            return {
                code: 0,
                msg: "未匹配到录音文件"
            }
        }

        /* 将录音文件复制到应用存储目录 */
        const last_audio = copy(audio.file);

        /* 开始上传录音文件 */
        const result = await upload(last_audio, param);

        /* 删除原文件，防止卡顿 */
        if (result.status === 1) unlink(audio.file);

        return result;

    } catch (e) {
        return {
            code: 0,
            msg: e.message
        };
    }
}


/**
 * 获取当前设备的通话状态
 * 通过TelephonyManager获取实时通话状态信息
 *
 * 返回值说明：
 * - 0: 空闲状态（无通话）
 * - 1: 来电响铃状态
 * - 2: 通话中状态（正在拨号、活动通话或保持状态）
 *
 * @returns {number} 当前通话状态码
 */
export function getState() {
    /* 确保Android类已初始化 */
    construct();
    /* 返回当前通话状态 */
    return teleManager.getCallState();
}


/**
 * 将应用从后台切换到前台
 * 当应用在后台运行时，调用此函数可以将应用窗口置于最前端
 * 常用于通话结束后自动显示应用界面
 */
export function moveTop() {
    /* 确保Android类已初始化 */
    construct();
    /* 获取当前应用的主Activity */
    const main = plus.android.runtimeMainActivity();
    /* 使用ActivityManager将当前任务移到前台，flags参数为0表示无特殊标志 */
    ActivityManager.moveTaskToFront(main.getTaskId(), 0);
}


/**
 * 批量清理设备中的通话录音文件
 * 遍历录音存储目录，删除所有录音文件以释放存储空间
 * 提供用户手动清理录音的功能，操作完成后会显示清理结果
 * @returns {void} 无返回值，通过load组件显示操作结果
 */
export function clear() {

    /* 获取当前设备的录音存储目录 */
    const save_path = getRecordPath();

    /* 检查是否成功获取录音存储目录 */
    if (!save_path) {
        load.toast("录音目录读取失败");
        return;
    }

    /* 创建目录文件对象 */
    const Dirs = new File(save_path);
    /* 获取目录下所有文件列表 */
    const files = Dirs.listFiles();

    /* 检查目录中是否存在文件 */
    if (!files) {
        load.toast("录音读取失败");
        return;
    }

    /* 遍历文件列表，删除所有录音文件 */
    let count = 0; /* 记录已删除的文件数量 */
    files.forEach(function (item) {
        /* 只处理文件，跳过目录 */
        if (item.isFile()) {
            /* 尝试删除文件并统计成功删除的数量 */
            if (unlink(item.getAbsolutePath())) {
                count++;
            }
        }
    })

    /* 显示清理结果 */
    load.info("清理完成！共删除" + count + "个录音文件");
}
